export const ASSESSMENT_SUMMARY_ITEMS = [
  {
    id: "business",
    label: "Daily Overview",
    tone: "green",
    // sourceCollections: ["foundational_business_reality_summary"],
    sourceCollections: ["shop_daily_overview"],
    sectionKeys: [
      "daily_overview",
      "benchmark",
      "meta",
      "gsc",
      "merchant_center",
      "revenue_reality",
      "market",
      "target_audience",
      "competitor",
      "yearly_content",
    ],
  },
  {
    id: "homepage",
    label: "Home Page",
    tone: "green",
    sourceCollections: ["shop_benchmark_report"],
    sectionKeys: ["benchmark"],
  },
  {
    id: "social",
    label: "Social Media",
    tone: "amber",
    sourceCollections: ["social_media_report"],
    sectionKeys: [],
  },
  {
    id: "conversion",
    label: "PDP",
    tone: "amber",
    sourceCollections: ["conversion_and_pdp_report"],
    sectionKeys: [],
  },
  {
    id: "performance",
    label: "Performance",
    tone: "green",
    sourceCollections: ["shop_benchmark_report", "shop_meta", "shop_meta_performance"],
    sectionKeys: ["benchmark", "meta"],
  },
  {
    id: "revenue",
    label: "Revenue Reality",
    tone: "green",
    sourceCollections: [
      "revenue_reality_full_report",
      "revenue_reality_unit_economics",
      "revenue_reality_customer_acquisition_health",
      "revenue_reality_channels_bring_real_orders",
      "revenue_reality_repeat_purchases",
      "revenue_reality_scale_spend",
      "revenue_reality_diversification",
      "revenue_reality_margin_discount",
      "revenue_reality_repeatability_score",
      "fixed_cost_viability",
      "product_sku_economics",
      "customer_lifetime_economics",
      "growth_efficiency_channel_mix",
      "margin_stability_and_risk",
      "operational_readiness_data_confidence",
    ],
    sectionKeys: ["revenue_reality"],
  },
  // {
  //   id: "market",
  //   label: "Market & competitors",
  //   tone: "green",
  //   sourceCollections: ["shop_market_analysis", "shop_competitor_analysis"],
  //   sectionKeys: ["market", "competitor"],
  // },
  // {
  //   id: "visibility",
  //   label: "Visibility",
  //   tone: "green",
  //   sourceCollections: [
  //     "google_search_console",
  //     "crawled_not_indexed",
  //     "shop_organic_visibility",
  //     "click_attraction",
  //     "alignment_with_intent",
  //     "brand_recall",
  //     "initial_engagement",
  //     "light_engagement",
  //     "google_merchant_center",
  //     "merchant_center",
  //   ],
  //   sectionKeys: ["gsc", "merchant_center"],
  // },
  // {
  //   id: "retention",
  //   label: "Retention",
  //   tone: "amber",
  //   sourceCollections: ["shop_benchmark_report", "revenue_reality_full_report"],
  //   sectionKeys: ["benchmark", "revenue_reality"],
  // },
  // {
  //   id: "content",
  //   label: "Content & creatives",
  //   tone: "red",
  //   sourceCollections: ["yearly_content_calendar", "marketing_calendar", "shop_target_audience"],
  //   sectionKeys: ["target_audience", "yearly_content"],
  // },
];

export const ASSESSMENT_SUMMARY_ITEM_BY_ID = Object.fromEntries(
  ASSESSMENT_SUMMARY_ITEMS.map((item) => [item.id, item]),
);

export const SUMMARY_SECTION_LABELS = {
  daily_overview: "Daily Overview",
  benchmark: "Store summary",
  meta: "Meta ads",
  gsc: "Google Search Console",
  merchant_center: "Google Merchant Center",
  revenue_reality: "Revenue reality",
  market: "Market analysis",
  target_audience: "Target audience",
  competitor: "Competitor analysis",
  yearly_content: "Monthly events calendar",
};

export const ASSESSMENT_HEADER_TITLE_BY_ID = {
  business:       "Daily Overview",
  homepage:       "Home Page Assessment",
  social:         "Social Media Assessment",
  performance:    "Performance Assessment",
  revenue:        "Revenue Reality Assessment",
  market:         "Market & Competitors Assessment",
  visibility:     "Visibility Assessment",
  conversion:     "Conversion Assessment",
  retention:      "Retention Assessment",
  content:        "Content & Creatives Assessment",
};

export function buildAssessmentHeaderMeta({
  summaryId,
  seededTitle = null,
  assessmentData = null,
  backingReport = null,
}) {
  const title =
    ASSESSMENT_HEADER_TITLE_BY_ID[summaryId] ||
    assessmentData?.title ||
    backingReport?.title ||
    seededTitle ||
    "Assessment";

  const updatedAt =
    assessmentData?.updatedAt ||
    backingReport?.updatedAt ||
    backingReport?.createdAt ||
    backingReport?.createdDate ||
    null;

  return {
    title,
    updatedAt,
    source: "assessment",
    entityId: summaryId || null,
  };
}

export const formatAssessmentDateLabel = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};
